export const sliceString = (str: string, maxNumber: number): string => {
  if (!str) return '';
  if (str.length <= maxNumber) return str;
  return str.slice(0, maxNumber);
};
